<lib-admin-panel></lib-admin-panel>
<div class="d-flex flex-column h-100">
  <app-header *ngIf="!hideHeaderFooter"></app-header>

  <main
    role="main"
    class="flex-fill"
    [ngClass]="{
      'header-fixed': headerFixed && !hideHeaderFooter,
      'with-navbar': (authenticatedUser$ | async) !== null
    }"
  >
    <router-outlet></router-outlet>
  </main>

  <div class="toggle-header d-flex flex-column" *ngIf="(authenticatedUser$ | async) !== null && displayUserlane">
    <div class="arrow-wrapper d-flex justify-content-end" (click)="isOpen = !isOpen">
      <div class="arrow-backgroud-wrapper d-flex align-items-center justify-content-center">
        <span class="arrow" [class.open]="isOpen"></span>
      </div>
    </div>
    <app-userlane-button class="userlaneButton" *ngIf="isOpen"></app-userlane-button>
  </div>

  <app-footer-top-nav *ngIf="!hideHeaderFooter" [loggedIn]="(authenticatedUser$ | async) !== null"></app-footer-top-nav>
  <app-footer
    class="mt-auto"
    *ngIf="!hideHeaderFooter"
    [ngClass]="{
      'col-md-9': (authenticatedUser$ | async) === null
    }"
  ></app-footer>
</div>
